// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Zdw8P4MxpXAKStH1jwKT{justify-content:flex-start;margin-bottom:24px;display:flex}.fvse1OAzesiqL4tFhWMy{background:var(--background-neutral-subtle);border-radius:8px;flex-direction:column;margin-top:40px;margin-bottom:32px;padding:16px;display:flex}.OfukFi2Pgyk04cwWqYjo{background-color:var(--black-20);height:1px;margin-top:4px;margin-bottom:14px}.qwqMvd0xAQ0behTEIgGK{margin-top:24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Zdw8P4MxpXAKStH1jwKT`,
	"summary": `fvse1OAzesiqL4tFhWMy`,
	"divider": `OfukFi2Pgyk04cwWqYjo`,
	"dropdownCards": `qwqMvd0xAQ0behTEIgGK`
};
export default ___CSS_LOADER_EXPORT___;
